<script>
import options from './PersonalFundraisingDashboardMenu.options'
export default options
</script>

<template>
  <div
    v-if="hasMenu"
    ref="rootEl"
    class="kb-personal-fundraising-dashboard-menu"
    @focusout="handleFocusout"
  >
    <button
      ref="triggerEl"
      type="button"
      class="kb-personal-fundraising-dashboard-menu__trigger"
      aria-haspopup="menu"
      :aria-controls="menuId"
      :aria-expanded="isOpen"
      @click="toggleMenu"
    >
      <span
        class="kb-personal-fundraising-dashboard-menu__ellipsis kb-ui-icon kb-ui-icon--ui-dots-horizontal"
        aria-hidden="true"
      ></span>
      <span>{{ triggerLabel }}</span>
    </button>

    <div
      v-if="isOpen"
      class="kb-personal-fundraising-dashboard-menu__backdrop"
      aria-hidden="true"
      @click="closeMenu(true)"
    ></div>

    <ul
      v-if="isOpen"
      :id="menuId"
      ref="menuEl"
      class="kb-personal-fundraising-dashboard-menu__popover"
      :class="{
        'kb-personal-fundraising-dashboard-menu__popover--above': opensAbove
      }"
      :style="menuStyle"
      role="menu"
      :aria-label="triggerLabel"
      @keydown="handleMenuKeydown"
    >
      <li
        class="kb-personal-fundraising-dashboard-menu__mobile-header"
        role="none"
      >
        <span
          class="kb-personal-fundraising-dashboard-menu__drawer-handle"
          aria-hidden="true"
        ></span>
        <button
          type="button"
          class="kb-personal-fundraising-dashboard-menu__close"
          :aria-label="`Luk ${triggerLabel.toLowerCase()}`"
          @click="closeMenu(true)"
        >
          <span
            class="kb-ui-icon kb-ui-icon--ui-close"
            aria-hidden="true"
          ></span>
        </button>
      </li>
      <li v-if="showUpdateTarget" role="none">
        <a
          class="kb-personal-fundraising-dashboard-menu__menu-item"
          :href="fundraisingTargetUrl"
          role="menuitem"
          @click="closeMenu()"
        >
          <span>{{ updateTargetLabel }}</span>
          <span class="kb-ui-icon kb-ui-icon--ui-pen" aria-hidden="true"></span>
        </a>
      </li>
      <li v-if="qrCodeImage" role="none">
        <button
          type="button"
          class="kb-personal-fundraising-dashboard-menu__menu-item"
          role="menuitem"
          @click="openQrCodeOverlay"
        >
          <span>{{ qrCodeLabel }}</span>
          <span
            class="kb-ui-icon kb-ui-icon--ui-qr-code"
            aria-hidden="true"
          ></span>
        </button>
      </li>
      <li v-if="livestreamUrl" role="none">
        <a
          class="kb-personal-fundraising-dashboard-menu__menu-item"
          :href="livestreamUrl"
          role="menuitem"
          @click="closeMenu()"
        >
          <span>{{ livestreamLabel }}</span>
          <span
            class="kb-ui-icon kb-ui-icon--ui-livestream"
            aria-hidden="true"
          ></span>
        </a>
      </li>
    </ul>
  </div>
</template>
